// src/pages/EventsPage.js
import React from "react";
import { motion } from "framer-motion";
import { Button } from "../components/UI/button";

const EventsPage = () => {
  return (
    <div className="bg-black text-white min-h-screen p-4">
      <header className="text-center py-10">
        <img
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-J9azQPgps5nEQJgcMutOHujoHWGnYU.png"
          alt="Team CodeMe Logo"
          className="mx-auto w-20 mb-6"
        />
        <h1 className="text-4xl font-bold text-green-500">Upcoming Events</h1>
      </header>
      <main className="mt-10 max-w-7xl mx-auto">
        <motion.section
          className="bg-gray-800 p-6 rounded-2xl shadow-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-2xl font-semibold text-green-500">Web Development Workshop</h2>
          <p className="text-gray-300 mt-4">
            Learn modern Web Development with React and related technologies. Join us for an intensive hands-on session
            where you'll build real-world applications. Stay Tuned! Will inform your'll Soon.
          </p>
          <div className="mt-4">
            <p className="text-gray-300">Date: Coming Soon</p>
            <p className="text-gray-300">Time: Coming Soon</p>
            <p className="text-gray-300">Location: Coming Soon</p>
          </div>
          <Button variant="default" className="mt-4">
            Register Now
          </Button>
        </motion.section>
        <motion.section
        className="bg-gray-800 p-6 rounded-2xl shadow-md mt-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-semibold text-green-500">Digital Marketing Masterclass</h2>
        <p className="text-gray-300 mt-4">
          Master the latest digital marketing strategies and tools. Perfect for beginners and intermediate marketers
          looking to enhance their skills.
        </p>
        <div className="mt-4">
            <p className="text-gray-300">Date: Coming Soon</p>
            <p className="text-gray-300">Time: Coming Soon</p>
            <p className="text-gray-300">Location: Coming Soon</p>
        </div>
        <Button variant="default" className="mt-4">
          Register Now
        </Button>
      </motion.section>
      </main>
    </div>
  );
};

export default EventsPage;
